module.exports = __webpack_public_path__ + "static/media/TheCollectiveBecome-Medium.dfa4d061.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/TheCollectiveBecome-Medium.ttf
// module id = 731
// module chunks = 0